import React from 'react';
import { Navigate } from 'react-router';
import { Box, Divider, Tab, Tabs, Typography } from '@mui/material';
import CheckBoxAutoComplete from '../utils/CheckboxesAutoComplete';
import { AutocompleteInput } from 'react-admin';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import { ReferenceInput } from 'react-admin';
import { Dispatch, SetStateAction } from 'react';
import { BrokerDataType } from '../utils/DataTypes';
import { SetPropsType } from '../utils/CheckboxesAutoComplete';

const getOptionLabel = (option: BrokerDataType) => {
  return option.vendor_name;
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const renderOptions = (props, option, { selected }) => (
  <li {...props}>
    <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
    {option.vendor_name}
  </li>
);

const BrokerFilter = ({ setFunction }: SetPropsType) => {
  return (
    <>
      <ReferenceInput
        label="Broker"
        source="vendor_name"
        reference="Broker"
        sx={{ textTransform: 'capitalize', width: 300 }}
        optionText="vendor_name"
      >
        <CheckBoxAutoComplete
          setFunction={setFunction}
          label="Broker"
          // placeholder=''
          //getOptionLabel={getOptionLabel}
          renderOptions={renderOptions}
          getOptionLabel={getOptionLabel}
          //uiParams={uiParams}
        ></CheckBoxAutoComplete>
      </ReferenceInput>
    </>
  );
};

export default BrokerFilter;
